import { render } from "./RequisitesPhoneGroupRow.vue?vue&type=template&id=3cdbb159&scoped=true&ts=true"
import script from "./RequisitesPhoneGroupRow.vue?vue&type=script&lang=ts"
export * from "./RequisitesPhoneGroupRow.vue?vue&type=script&lang=ts"

import "./RequisitesPhoneGroupRow.vue?vue&type=style&index=0&id=3cdbb159&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cdbb159"]])

export default __exports__